import { Group } from "./Group";
import { For, Show } from "solid-js";
import { Flexbox, Icon, processResponseActions, showProgressDialog } from "st-app";
import { ViewSuggestion, roleDashboard as api } from "sis-app/api";
import { requireRoleDashboardContext } from "../RoleDashboardContext";

import styles from '../sis-role-dashboard.module.css'

export function UserSuggestions() {
    const ctx = requireRoleDashboardContext();

    return <Show when={ctx.suggestions().length > 0}>
        <Group title="Suggestions" icon="fas fa-bolt" color="--header-violet">
            <For each={ctx.suggestions()}>{suggestion => <Suggestion {...suggestion} />}</For>
        </Group>
    </Show>
}

function Suggestion(props: ViewSuggestion) {
    const ctx = requireRoleDashboardContext();

    // Route the server's Open_Window response into the drawer. The server decides
    // whether to include a data request based on whether a primary identity is
    // cached for the view's primary BO, so student-focused views open in find mode
    // rather than erroring on a missing identity.
    function handleXmlResponse(xml: HTMLElement): boolean {
        const type = xml.getAttribute('TYPE');
        if (type === 'Open_Window' && xml.getAttribute('MODAL') !== 'YES' && !ctx.launchDetached()) {
            ctx.setViewDrawerTitle(props.viewName ?? '');
            ctx.setViewDrawerRequest(xml.innerHTML);
            return true;
        }
        return false;
    }

    function openView(detached: boolean) {
        if (detached) {
            const st = (window.top ?? window)?.ST;
            if (st) {
                st.LoadView(props.viewType, props.viewGU, detached, false);
            }
        }
        else {
            ctx.setLaunchDetached(false);
            showProgressDialog("Loading...",
                api.OpenSuggestion(props.viewGU ?? '', props.viewType ?? '').then(res => {
                    processResponseActions(res, { handleXml: handleXmlResponse });
                })
            );
        }
    }

    function openDetached(ev: Event) {
        openView(true);
        ev.stopPropagation();
    }

    return <Flexbox dir="vertical" middle onClick={() => openView(false)} class={styles.action} role="button">
        <div class={styles.detach} role="button" onClick={openDetached} >
            <Icon src="fa fa-external-link" />
        </div>
        <div style="height: 50px; line-height: 60px" >
            <Icon src={props.viewIcon ?? ''} size={48} />
        </div>
        <Flexbox.Item as="span" class={styles.label}>{props.viewName}</Flexbox.Item>
    </Flexbox>
}
